module.exports = ".chat-img{\n    width: 70px;\n    position: fixed;\n    right: 30px;\n    bottom: 25px;\n    cursor: pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/chat-bot-icon/chat-bot-icon.component.css
// module id = ./src/app/feature/main/roles-shared/chat-bot-icon/chat-bot-icon.component.css
// module chunks = main